import React, { PureComponent } from 'react'
import styled from 'styled-components'
import _ from 'lodash'

class Skills extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      skills: this.props.skills ? this.props.skills.split('; ') : []
    }
  }

  handleGeneraliste = () => {
    const checkboxes = document.getElementsByClassName('skills')
    const general = document.getElementById('Généraliste')
    for (var i = 0; i < checkboxes.length; i++) {
      checkboxes[i].checked = general.checked
    }
  }

  handleSkillClick = e => {
    let skills
    if (this.props.skills.length !== 0) {
      skills = [...this.props.skills.split('; ')]
    } else {
      skills = []
    }
    console.log('skills split: ', this.props.skills.split('; '))
    console.log(this.props.skills.split('; ').indexOf(e.target.value))
    if (this.props.skills.split('; ').indexOf(e.target.value) === -1) {
      skills.push(e.target.value)
      console.log('skills', skills)
      // console.log(skills.join('; '))
      this.props.handleSkillsChange(skills.join('; '))
    } else {
      let supp = []
      supp = skills.splice(
        this.props.skills.split('; ').indexOf(e.target.value),
        1
      )
      console.log('supp', skills)
      if (skills.length !== 1) {
        this.props.handleSkillsChange(skills.join('; '))
      } else {
        this.props.handleSkillsChange(skills[0])
      }
    }
  }

  componentDidMount() {
    // console.log('card skills: ', this.props.skills)
  }

  render() {
    console.log(this.props.skills)
    return (
      <div>
        {this.props.newCat.map(
          (item, key) =>
            item[0] === 'Généraliste' ? (
              <div key={key}>
                <fieldset style={{ width: '80%' }}>
                  <input
                    type="checkbox"
                    className="skills"
                    onClick={this.handleSkillClick}
                    id="Généraliste"
                    value="Généraliste"
                    defaultChecked={
                      this.props.skills
                        ? this.props.skills
                            .split('; ')
                            .indexOf('Généraliste') !== -1
                        : false
                    }
                  />
                  <label htmlFor="Généraliste">Généraliste</label>
                </fieldset>
              </div>
            ) : (
              <div key={key}>
                <fieldset style={{ width: '80%' }}>
                  <legend>{item[0]}</legend>
                  {item[1].map((a, i) => {
                    return (
                      <div key={i}>
                        <input
                          type="checkbox"
                          className="skills"
                          onClick={this.handleSkillClick}
                          id={a}
                          value={a}
                          defaultChecked={
                            this.props.skills
                              ? this.props.skills.split('; ').indexOf(a) !== -1
                              : false
                          }
                        />
                        <label htmlFor={a}>{a}</label>
                      </div>
                    )
                  })}
                </fieldset>
              </div>
            )
        )}
      </div>
    )
  }
}

export default Skills



// WEBPACK FOOTER //
// ./src/components/admin/skills.js